// extracted by mini-css-extract-plugin
export default {"card":"CardSellers_card__pekVU","header":"CardSellers_header__fIBuL","photo":"CardSellers_photo__JWoIe","name":"CardSellers_name__wSpLc","link":"CardSellers_link__VzNDF"};